import { clearUserSession, isUnauthorizedResponse, userFetch } from './userAuth';

const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api';

class AgencyApiError extends Error {
    constructor(message: string, public status: number, public isTokenExpired: boolean = false) {
        super(message);
        this.name = 'AgencyApiError';
    }
}

const handleAgencyResponse = async (response: Response) => {
    if (isUnauthorizedResponse(response)) {
        clearUserSession();
        throw new AgencyApiError('Authentication failed. Please log in again.', response.status, true);
    }

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
        throw new AgencyApiError(errorData.message || `HTTP ${response.status}`, response.status);
    }

    return response.json();
};

export const agencyApi = {
    // GET request
    get: async (endpoint: string) => {
        const response = await userFetch(`${VITE_API_BASE_URL}/agency${endpoint}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        });

        return handleAgencyResponse(response);
    },

    // POST request
    post: async (endpoint: string, data: any) => {
        const response = await userFetch(`${VITE_API_BASE_URL}/agency${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(data),
        });

        return handleAgencyResponse(response);
    },

    // PUT request
    put: async (endpoint: string, data: any) => {
        const response = await userFetch(`${VITE_API_BASE_URL}/agency${endpoint}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(data),
        });

        return handleAgencyResponse(response);
    },

    // DELETE request
    delete: async (endpoint: string) => {
        const response = await userFetch(`${VITE_API_BASE_URL}/agency${endpoint}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        });

        return handleAgencyResponse(response);
    },
};

export { AgencyApiError };